/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import type { Calendar } from './Calendar';
import type { ActivityDefinition } from './ActivityDefinition';
/**
 * 
 * @export
 * @interface Assessment
 */
export interface Assessment {
    /**
     * 
     * @type {number}
     * @memberof Assessment
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Assessment
     */
    userId?: number;
    /**
     * 
     * @type {Date}
     * @memberof Assessment
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    activityTypeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    data?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Assessment
     */
    score?: number | null;
    /**
     * 
     * @type {ActivityDefinition}
     * @memberof Assessment
     */
    activityType?: ActivityDefinition;
    /**
     * 
     * @type {Calendar}
     * @memberof Assessment
     */
    dateNavigation?: Calendar;
    /**
     * 
     * @type {User}
     * @memberof Assessment
     */
    user?: User;
}

/**
 * Check if a given object implements the Assessment interface.
 */
export function instanceOfAssessment(value: object): value is Assessment {
    return true;
}

export function AssessmentFromJSON(json: any): Assessment {
    return AssessmentFromJSONTyped(json, false);
}

export function AssessmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Assessment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'activityTypeId': json['activityTypeId'] == null ? undefined : json['activityTypeId'],
        'data': json['data'] == null ? undefined : json['data'],
        'score': json['score'] == null ? undefined : json['score'],
        'activityType': json['activityType'] == null ? undefined : (require('./ActivityDefinition') as typeof import('./ActivityDefinition')).ActivityDefinitionFromJSON(json['activityType']),
        'dateNavigation': json['dateNavigation'] == null ? undefined : (require('./Calendar') as typeof import('./Calendar')).CalendarFromJSON(json['dateNavigation']),
        'user': json['user'] == null ? undefined : (require('./User') as typeof import('./User')).UserFromJSON(json['user']),
    };
}

export function AssessmentToJSON(json: any): Assessment {
    return AssessmentToJSONTyped(json, false);
}

export function AssessmentToJSONTyped(value?: Assessment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'activityTypeId': value['activityTypeId'],
        'data': value['data'],
        'score': value['score'],
        'activityType': (require('./ActivityDefinition') as typeof import('./ActivityDefinition')).ActivityDefinitionToJSON(value['activityType']),
        'dateNavigation': (require('./Calendar') as typeof import('./Calendar')).CalendarToJSON(value['dateNavigation']),
        'user': (require('./User') as typeof import('./User')).UserToJSON(value['user']),
    };
}

